import { gql } from '@apollo/client'

export const CMS_TRACKING_SITE_FIELDS = gql`
  fragment CmsTrackingSiteFields on CmsTrackingSiteExport {
    schoolId
    schoolName
    siteId
    siteLabel
    hostname
    hasUmami
    hasBeehivelyGtag
    hasSchoolGa4
    hasGtm
    hasMetaPixel
  }
`

export const COOKIE_CONSENT_SITES_EXPORT_QUERY = gql`
  query CookieConsentSitesExportQuery {
    cookieConsentSitesExport {
      ...CmsTrackingSiteFields
    }
  }
  ${CMS_TRACKING_SITE_FIELDS}
`

export const ANALYTICS_SITES_EXPORT_QUERY = gql`
  query AnalyticsSitesExportQuery {
    analyticsSitesExport {
      ...CmsTrackingSiteFields
    }
  }
  ${CMS_TRACKING_SITE_FIELDS}
`

const yesNo = (value) => (value ? 'Yes' : 'No')

export const COOKIE_CONSENT_EXPORT_COLUMNS = [
  { label: 'School ID', value: (row) => row.schoolId },
  { label: 'School Name', value: (row) => row.schoolName },
  { label: 'Site ID', value: (row) => row.siteId },
  { label: 'Site Label', value: (row) => row.siteLabel },
  { label: 'Hostname', value: (row) => row.hostname },
]

export const ANALYTICS_EXPORT_COLUMNS = [
  ...COOKIE_CONSENT_EXPORT_COLUMNS,
  { label: 'Umami', value: (row) => yesNo(row.hasUmami) },
  {
    label: 'Beehively Gtag',
    value: (row) => yesNo(row.hasBeehivelyGtag),
  },
  {
    label: 'Google Analytics (GA4)',
    value: (row) => yesNo(row.hasSchoolGa4),
  },
  { label: 'Google Tag Manager (GTM)', value: (row) => yesNo(row.hasGtm) },
  { label: 'Meta Pixel', value: (row) => yesNo(row.hasMetaPixel) },
]
